

/**
 * Class for storing the state of the TM ({@link TuringMachine})
 */
export class TmMemento {
    #currentState;                          // TmState
    #tape;                                  // string[]
    #currentHeadPosition;                   // number, index of head in tape
    #executedStepsCount;                    // number


    /**
     *
     * @param currentState {TmState}
     * @param tape {string[]}
     * @param currentHeadPosition {number}
     * @param executedStepsCount {number}
     */
    constructor(currentState, tape, currentHeadPosition, executedStepsCount) {
        this.#currentState = currentState;
        this.#tape = tape;
        this.#currentHeadPosition = currentHeadPosition;
        this.#executedStepsCount = executedStepsCount;
    }

    get currentState() {
        return this.#currentState;
    }

    get tape() {
        return this.#tape;
    }

    get currentHeadPosition() {
        return this.#currentHeadPosition;
    }

    get executedStepsCount() {
        return this.#executedStepsCount;
    }
}